<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
</script>

<template>
  <div class="mt-8">
    <p class="text-foreground-dim text-sm mb-4 uppercase tracking-widest">Pas encore sûr ? Découvrez l'univers OXO</p>
    <div class="flex flex-wrap justify-center gap-4">
      <AppButton to="/projets" variant="outline" size="sm" class="border-oxo-border text-foreground-dim hover:bg-foreground hover:text-background hover:border-foreground">
        Projets Étudiants
      </AppButton>
      <AppButton to="/ecole" variant="outline" size="sm" class="border-oxo-border text-foreground-dim hover:bg-foreground hover:text-background hover:border-foreground">
        L'École
      </AppButton>
      <AppButton to="/actus" variant="outline" size="sm" class="border-oxo-border text-foreground-dim hover:bg-foreground hover:text-background hover:border-foreground">
        Actualités
      </AppButton>
    </div>
  </div>
</template>
